import { FaDownload } from "react-icons/fa6";
import DateHelper from "@helpers/DateHelper";
import Version from "@ltypes/version";
import Product from "@ltypes/product";
import Card from "@components/ui/Card/Card";
import Button from "@components/forms/Button/Button";
import ProductService from "@services/ProductService";
import "./Update.scss";
import { useRef, useState } from "react";
import toast from "react-hot-toast";

type UpdateProps = {
    product: Product,
    version: Version,
    onUpdate: (newProduct: Product) => void,
};

function Update(props: UpdateProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [updating, setUpdating] = useState<boolean>(false);

    const service = new ProductService;
    const timerRef = useRef<any>(null);

    const handleDownload = () => {
        setLoading(true);
        service.updateFirmware(props.product.id).then(() => {
            setUpdating(true);

            let nbTry = 0;

            clearInterval(timerRef.current);
            timerRef.current = setInterval(() => {
                service.get(props.product.id).then((data: any) => {
                    const newProduct: Product = data.body;
                    // updated
                    if(newProduct.version.name === props.version.name) {
                        setUpdating(false);
                        clearInterval(timerRef.current);
                        props.onUpdate(newProduct);
                        toast.success('Lumeba updated 🥳 !');
                    }
                    else {
                        nbTry++;
                    }

                    if(nbTry >= 30) {
                        clearInterval(timerRef.current);
                    }
                }).catch(e => {
                });
            }, 3000);
        }).catch(() => {
            setUpdating(false);
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <Card className="update" color="primary">
            <div className="row">
                <div className="col-auto">
                    <div className="update-icon">
                        <FaDownload/>
                    </div>
                </div>
                <div className="col">
                    {!updating ? (
                        <div className="row">
                            <div className="col-12">
                                <span className="update-label">Update available !</span>
                            </div>
                            <div className="col-12">
                                <ul className="update-infos">
                                    <li>Firmware: {props.version.name}</li>
                                    <li>Date: {DateHelper.formatDate(props.version.created_at)}</li>
                                </ul>
                            </div>

                            {props.version.changelog && (
                                <div className="col-12">
                                    <ul className="update-changelog">
                                        {props.version.changelog
                                            .split(/\\r\\n|\\n|\r\n|\n/)
                                            .map(line => line.trim())
                                            .filter(line => line.length > 0)
                                            .map((line, index) => (
                                                <li key={index}>{line}</li>
                                            ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-12">
                                <span className="update-label">Update in progress...</span>
                            </div>
                            <div className="col-12 pt-3">
                                <div className="progress-bar">
                                    <div className="progress-bar-value"></div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {!updating && (
                <div className="row">
                    <div className="col-12">
                        <Button size="sm" onClick={handleDownload} filled disabled={!props.product.is_connected || loading}>{!props.product.is_connected ? 'Lumeba is offline 😔' : 'Download'}</Button>
                    </div>
                </div>
            )}
        </Card>
    );
}

export default Update;
